export default __webpack_public_path__ + "static/media/hover.8899f4a0.svg";